<template>
  <div class="login_loading">
    <Loading tips="跳转中，请稍候..."></Loading>
  </div>
</template>

<script>
import Loading from '@/components/ui/Loading'
export default {
  name: 'LoginLoading',
  components: {
    Loading,
  },
}
</script>

<style scoped>
.login_loading{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
